/**
 * UpdateBanner — thin blue bar shown when a new service worker has activated
 * but the reload is deferred because a chat is actively streaming. Joseph
 * can tap "Reload" to force it.
 */

import { computed } from '@preact/signals';
import { updateReady, reloadNow } from '../core/sw/update';

/** BannerSlot coordination (P1a): mirrors this banner's own visibility rule. */
export const updateBannerWantsToShow = computed(() => updateReady.value);

export function UpdateBanner() {
  if (!updateReady.value) return null;

  return (
    <div style={styles.banner} role="status" aria-live="polite">
      <span style={styles.text}>Update ready. Reloading when idle.</span>
      <button
        style={styles.btn}
        onClick={reloadNow}
        aria-label="Reload now to apply update"
      >
        Reload
      </button>
    </div>
  );
}

const styles: Record<string, Record<string, string | number>> = {
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '6px 12px',
    background: 'var(--accent)',
    color: 'var(--text-on-accent)',
    fontSize: '12px',
    fontWeight: '600',
    flexShrink: '0',
  },
  text: {
    whiteSpace: 'nowrap',
  },
  btn: {
    background: 'rgba(255, 255, 255, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '4px',
    padding: '2px 10px',
    color: 'inherit',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: 'var(--font)',
  },
};
